var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "shop",
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.994,
    height: 49.994,
    viewBox: "0 0 49.994 49.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.914,25.58H14.665C4.374,25.58,0,21.185,0,10.915V1.562A1.574,1.574,0,0,1,1.562,0,1.574,1.574,0,0,1,3.125,1.562v9.353c0,8.52,3.02,11.54,11.54,11.54H25.893c8.52,0,11.54-3.02,11.54-11.54V1.562a1.562,1.562,0,0,1,3.125,0v9.353C40.579,21.185,36.183,25.58,25.914,25.58Z",
    transform: "translate(4.708 21.81)",
    fill: "#ef7a30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M7.834,23.956A7.715,7.715,0,0,1,.043,15.332l1.4-13.915A1.579,1.579,0,0,1,3,0h9.728a1.563,1.563,0,0,1,1.562,1.417l1.4,13.915a7.79,7.79,0,0,1-1.937,6.083A7.982,7.982,0,0,1,7.834,23.956ZM4.4,3.125,3.147,15.644A4.657,4.657,0,0,0,4.293,19.31a5,5,0,0,0,7.083,0,4.706,4.706,0,0,0,1.146-3.666L11.271,3.125Z",
    transform: "translate(17.163 2.604)",
    fill: "#ef7a30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M9.9,23.956a8.672,8.672,0,0,1-8.437-7.624L.007,1.729A1.609,1.609,0,0,1,.4.521,1.531,1.531,0,0,1,1.569,0H7.923c6.124,0,8.978,2.562,9.832,8.853l.583,5.791A8.356,8.356,0,0,1,9.9,23.956ZM3.3,3.125,4.59,16.019A5.537,5.537,0,0,0,9.9,20.831a5.217,5.217,0,0,0,5.333-5.874l-.583-5.728c-.646-4.708-2.166-6.1-6.728-6.1Z",
    transform: "translate(28.24 2.604)",
    fill: "#ef7a30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M8.484,23.956A8.356,8.356,0,0,1,.047,14.644L.61,8.916C1.484,2.562,4.338,0,10.463,0h6.353a1.6,1.6,0,0,1,1.167.521,1.529,1.529,0,0,1,.4,1.208l-1.458,14.6A8.672,8.672,0,0,1,8.484,23.956ZM10.463,3.125C5.9,3.125,4.38,4.5,3.713,9.27l-.562,5.687a5.217,5.217,0,0,0,5.333,5.874A5.52,5.52,0,0,0,13.8,16.019L15.087,3.125Z",
    transform: "translate(3.265 2.604)",
    fill: "#ef7a30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M11.978,13.54H1.562A1.574,1.574,0,0,1,0,11.978V6.77C0,2.4,2.4,0,6.77,0s6.77,2.4,6.77,6.77v5.208A1.574,1.574,0,0,1,11.978,13.54ZM3.125,10.415h7.291V6.77c0-2.625-1.021-3.645-3.645-3.645S3.125,4.145,3.125,6.77Z",
    transform: "translate(18.227 33.85)",
    fill: "#ef7a30"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H49.994V49.994H0Z",
    fill: "none",
    opacity: 0
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.ea759da997f8f5df4c71a1d5e73d3593.svg";
export { ForwardRef as ReactComponent };